import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureNGPReport
export interface IFeatureNGPReport extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_NGP_REPORT_DEFAULT
export const _FEATURE_NGP_REPORT_DEFAULT: Readonly<IFeatureNGPReport & Object> = {
  displayText: NavigationPageEnumHumanReadable.NGPReport,
  feature: NavigationPageEnum.NGPReport,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion